<!--
 * @Description:
 * @Date: 2019-09-26 16:13:52
 -->
<template>
  <div class="risk-box">
    <el-form
      :disabled="isDialog"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="220px"
      class="ruleForm rmgt"
    >
      <div class="risk-tips">
        注：风控规则由平台保留最终解释权，所有风控内容最终以平台设置的可调范围为准。
      </div>
      <el-form-item label="任务最低间隔时间：" props="intervalTime">
        <el-input
          disabled
          :value="ruleForm.intervalTime || range.intervalTime"
          placeholder=""
        >
          <span slot="suffix">分钟</span>
        </el-input>
        <span class="note-s1">
          注：当前任务结束时间与下个任务开始时间间隔（线下场景生效）
        </span>
      </el-form-item>
      <el-form-item label="任务定位距离：">
        <div class="distance" v-for="(item, index) in list" :key="index">
          <span>任务间隔</span>
          <el-input
            v-model="item.minuteTime"
            disabled
            placeholder=""
            style="margin:0 12px"
          >
            <span slot="suffix">分钟</span>
          </el-input>
          <span>内，用户移动距离不得超过</span>
          <el-input
            v-model="item.distanceKilometre"
            disabled
            placeholder=""
            style="margin:0 30px 0 12px"
          >
            <span slot="suffix">公里</span>
          </el-input>
        </div>
      </el-form-item>
      <el-form-item label="执行者年龄区间：">
        <el-input
          disabled
          :value="ruleForm.ageStart || range.ageStart"
          placeholder=""
        >
          <span disabled slot="suffix">岁</span>
        </el-input>
        <span class="line"></span>
        <el-input
          disabled
          :value="ruleForm.ageEnd || range.ageEnd"
          placeholder=""
        >
          <span disabled slot="suffix">岁</span>
        </el-input>
      </el-form-item>
      <el-form-item
        label="不可重复拜访相同药店："
        prop="pharmacyInterval"
        :rules="
          validVisitPeople2(
            range.pharmacyIntervalIsUpdate
              ? range.pharmacyInterval
              : ruleForm.pharmacyInterval
          )
        "
      >
        <el-input
          :disabled="!range.pharmacyIntervalIsUpdate"
          v-model="ruleForm.pharmacyInterval"
          @blur="fommatNumber('pharmacyInterval')"
          placeholder=""
          v-if="!!isDialog || range.pharmacyIntervalIsUpdate"
        >
          <span slot="suffix">天内</span>
        </el-input>
        <el-input
          :disabled="true"
          v-model="range.pharmacyInterval"
          placeholder=""
          v-else
        >
          <span slot="suffix">天内</span>
        </el-input>
        <span v-if="+range.pharmacyInterval >= 0" class="note-s1">
          可调范围：大于等于{{ range.pharmacyInterval }}天
        </span>
      </el-form-item>
      <el-form-item
        label="单日用户最多可巡店次数："
        prop="pharmacyDaySum"
        :rules="validVisitcommon(1, range.pharmacyDaySum, '次')"
      >
        <el-input
          :disabled="!range.pharmacyDaySumIsUpdate"
          v-model="ruleForm.pharmacyDaySum"
          placeholder=""
        >
          <span slot="suffix">次</span>
        </el-input>
        <span v-if="range.pharmacyDaySumIsUpdate" class="note-s1">
          可调范围：1 - {{ range.pharmacyDaySum }}次
        </span>
      </el-form-item>
      <el-form-item
        label="巡店时间："
        prop="startTime"
        :rules="
          validVisitTime(
            range.startTime,
            range.endtTime ? range.endtTime : range.entTime,
            ruleForm.startTime,
            ruleForm.endTime,
            range.timeIsUpdate
          )
        "
      >
        <div class="form-item-flex">
          <el-time-picker
            value-format="HH:mm"
            :class="{ 'hidden-ss': ruleForm.startTime }"
            :disabled="!range.timeIsUpdate"
            v-model="ruleForm.startTime"
            :picker-options="timeSelectOptions"
            placeholder="选择时间"
          ></el-time-picker>
          <span class="line"></span>
          <el-time-picker
            :class="{ 'hidden-ss': ruleForm.entTime || ruleForm.endTime }"
            value-format="HH:mm"
            :disabled="!range.timeIsUpdate"
            v-model="ruleForm.endTime"
            :picker-options="timeSelectOptions"
            placeholder="选择时间"
          ></el-time-picker>
          <span class="note-s1" v-if="range.timeIsUpdate">
            可调范围：{{ range.startTime }}-{{
              range.entTime ? range.entTime : range.endTime
            }}
          </span>
        </div>
      </el-form-item>
      <template v-if="!isDialog">
        <el-form-item>
          <!--          {{ruleForm.enableDt|time}}-->
          <span style="color:#9D9D9D">注：所有修改内容将于次日0:00生效</span>
        </el-form-item>
        <div style="display: flex;justify-content: center">
          <el-button type="primary" class="bts" @click="save">保存</el-button>
          <el-button type="primary" class="bts" @click="record">
            风控记录
          </el-button>
        </div>
      </template>
    </el-form>
  </div>
</template>

<script>
import { makeSure } from '@/Mixin/makeSure';
import mixins from '../mixins/index';

export default {
  mixins: [makeSure, mixins],
  name: 'otc',
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: function() {
        return {};
      }
    },

    listobj: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    fommatNumber(key) {
      this.ruleForm[key] = this.ruleForm[key].replace(/[^0-9]/g, '');
    }
  }
};
</script>
<style lang="scss">
.rmgt {
  .el-input__suffix {
    right: 12px;
    color: #000;
  }
}

.risk-box {
  .ruleForm .el-form-item .el-input {
    width: 160px;
  }
}
</style>
<style scoped lang="scss">
.ruleForm {
  padding: 0;
}

.risk-tips {
  color: #9d9d9d;
  font-size: 13px;
  margin-bottom: 40px;
}

.note-s1 {
  margin-left: 30px;
  color: #9d9d9d;
  font-size: 13px;
}

.distance {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.check {
  position: absolute;
  right: 30.68%;
}

.line {
  width: 16px;
  height: 1px;
  background: #dedede;
  margin: 0 12px;
  display: inline-block;
}
</style>
